import { API_LOAD_EMPLOYEE_STATS } from './employeeStats.reducer';

const dateToString = date => date.substring(0, date.indexOf('T'));

export const load = (start, end) => ({
  resourceAction: API_LOAD_EMPLOYEE_STATS,
  query: `?q[workorder_status_eq]=approved&q[workorder_wo_date_gteq]=${dateToString(start)}&q[workorder_wo_date_lteq]=${dateToString(end)}`,
});



// WEBPACK FOOTER //
// ./src/reducers/employeeStats/employeeStats.actions.js